type GtagFn = (
  command: "event",
  eventName: string,
  params?: Record<string, unknown>,
) => void;

declare global {
  interface Window {
    gtag?: GtagFn;
    dataLayer?: unknown[];
  }
}

function fire(event: string, params: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
    return;
  }
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({ event, ...params });
  }
}

export function trackOutboundClick(args: {
  productId: string | number;
  retailer: string;
  price: number | null;
  url: string;
  affiliate: boolean;
}): void {
  fire("select_item", {
    item_id: String(args.productId),
    item_brand: args.retailer,
    item_category: "outbound_retailer",
    affiliation: args.affiliate ? "affiliate" : "direct",
    currency: "USD",
    value: args.price ?? undefined,
    link_url: args.url,
  });
}

export function trackSearchSubmit(query: string, surface: "home" | "header"): void {
  if (!query.trim()) return;
  fire("search", {
    search_term: query,
    search_surface: surface,
  });
}
